/** Shared engine constants organized in a plain object. */
export const EngineConstants = {
  // Profile image constraints.
  Profile: {
    /** Maximum avatar dimension in pixels (width and height). */
    AvatarMaxSize: 256,
    /** JPEG compression quality (0-1). */
    AvatarQuality: 0.8
  },

  /** Firebase Auth error codes. */
  AuthErrorWrongPassword: 'auth/wrong-password',
  AuthErrorInvalidCredential: 'auth/invalid-credential',
  AuthErrorEmailAlreadyInUse: 'auth/email-already-in-use',
  /** Identity Platform legacy weak-password code (returned when password fails minimum-strength rule). */
  AuthErrorWeakPassword: 'auth/weak-password',
  /** Identity Platform code returned when the new password violates the configured password policy. */
  AuthErrorPasswordDoesNotMeetRequirements: 'auth/password-does-not-meet-requirements',
  /** Prefix shared by every Firebase Auth error code. */
  AuthErrorPrefix: 'auth/',
  /** Anomalous auth error codes that indicate a system/abuse condition (not routine user input), so they log at Warn rather than Debug. */
  AuthErrorNetworkRequestFailed: 'auth/network-request-failed',
  AuthErrorInternalError: 'auth/internal-error',
  AuthErrorTooManyRequests: 'auth/too-many-requests'
} as const;
